<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h2>Aviso</h2>
      <p>{{ message }}</p>
      <button class="btn-ok" @click="$emit('close')">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      modalMessage: '',
    };
  },
  methods: {
    fecharModal() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped src="../styles/AlertModal.css"/>